export default {
  'page.user.login.form-item-username': 'Username',
  'page.user.login.form-item-username.required': 'Please input your username',
  'page.user.login.form-item-email': 'Email',
  'page.user.login.form.remember-me': 'Remember',
  'page.user.login.form-item-password': 'Password',
  'page.user.login.form-item-password.required': 'Please input your password',
  'page.user.login.form.title': 'Account Login',
  'page.user.login.form.btn-submit': 'Sign in',
  'page.user.login.form.btn-jump': 'Or Register now ?',
  'page.user.login.form.login-error': 'Wrong username or password!',
  'page.user.login.form.login-success': 'Login successful!',

  'page.user.register.form.btn-submit': 'Sign up',
  'page.user.register.form.btn-cancel': 'Cancel',

  'page.user.register.form.register-successfully': 'Register successfully!',

  'page.user.register.form.register-error':
    'An error occurred while registering new user!',

  'page.user.login.error.USER_ERROR_INCORRECT_USERNAME_OR_PASSWORD':
    'You have entered an invalid username or password',
  'page.user.login.error.USER_ERROR_UNACTIVATED':
    'The account has not been activated yet!',
  'page.user.register.form-item-password.required':
    'Please enter your password!',
  'page.user.register.form-item-password.min':
    'Password must contain at least 12 characters!',
  'page.user.register.form-item-password.pattern-rule':
    'Password must contain characters from at least 3 of these 4 groups: uppercase letters (A-Z), lowercase letters (a-z), numbers (0-9), and special characters.',
  'page.user.register.form-item-username.required':
    'Please enter your username!',
  'page.user.register.form-item-email.required': 'Please enter your email!',
  'page.user.register.form-item-email.invalid': 'Please enter a valid email!',
  'page.user.changePassword.success': 'Change password successfully!',
  'page.user.changePassword.success.redirect':
    'Change password successfully, will be logged out in 3 seconds',
  'page.user.changePassword.error': 'Change password failed!',
  'page.user.changePassword.form-item-password.required':
    'Please enter your new password!',
  'page.user.changePassword.form-item-password.mismatch':
    'The two passwords that you entered do not match!',
  'page.user.register.form-item-password.username-rule':
    'Password cannot contain your username',
  'page.user.register.title': 'Create New User',
  'page.user.currentPassword': 'Current Password',
  'page.user.newPassword': 'New Password',
  'page.user.confirmPassword': 'Confirm Password',
  'page.user.changePassword.samePassword': 'The passwords do not match!',
  'page.user.login.error.USER_IS_NOT_EXIST_IN_THE_SYSTEM':
    'User is not exist in the system.',
  'page.user.login.form-item-access-token': 'Access Token',
  'page.user.login.form-item-access-token.required':
    'Please input your access token',
};
